import React from 'react';
import CalendarDay from './CalendarDay';
import './CalendarGrid.css';

const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function CalendarGrid({ year, month, holidays, timeOff, userCountryId }) {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const startOffset = firstDay.getDay(); // 0 = Sunday
  const totalDays = lastDay.getDate();
  const today = new Date();

  // Build array of day cells: nulls for padding, then date numbers
  const cells = [];
  for (let i = 0; i < startOffset; i++) {
    cells.push(null);
  }
  for (let d = 1; d <= totalDays; d++) {
    cells.push(d);
  }

  // Index holidays by observed_date for fast lookup
  const holidaysByDate = {};
  for (const h of holidays) {
    const dateKey = h.observed_date || h.holiday_date?.observed_date;
    if (!dateKey) continue;
    const key = dateKey.substring(0, 10);
    if (!holidaysByDate[key]) holidaysByDate[key] = [];
    holidaysByDate[key].push(h);
  }

  // Index time off by date
  const timeOffByDate = {};
  for (const req of timeOff) {
    if (req.days) {
      for (const day of req.days) {
        const key = day.date?.substring(0, 10);
        if (!key) continue;
        if (!timeOffByDate[key]) timeOffByDate[key] = [];
        timeOffByDate[key].push({
          ...day,
          user_name: req.user_name,
          status: req.status,
        });
      }
    }
  }

  return (
    <div className="calendar-grid-container">
      <div className="calendar-grid-header">
        {DAY_LABELS.map(label => (
          <div key={label} className="calendar-grid-header-cell">{label}</div>
        ))}
      </div>
      <div className="calendar-grid">
        {cells.map((day, index) => {
          if (day === null) {
            return <div key={`empty-${index}`} className="calendar-day empty" />;
          }

          const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const isToday = today.getFullYear() === year && today.getMonth() === month && today.getDate() === day;
          const isWeekend = new Date(year, month, day).getDay() === 0 || new Date(year, month, day).getDay() === 6;
          const dayHolidays = holidaysByDate[dateStr] || [];
          const dayTimeOff = timeOffByDate[dateStr] || [];

          return (
            <CalendarDay
              key={dateStr}
              day={day}
              dateStr={dateStr}
              isToday={isToday}
              isWeekend={isWeekend}
              holidays={dayHolidays}
              timeOff={dayTimeOff}
              userCountryId={userCountryId}
            />
          );
        })}
      </div>
    </div>
  );
}

export default CalendarGrid;
